import React, { useEffect, useState } from "react";
import { MoneyInput } from "../../../../Componentes/MoneyInput";
import "./AcrescimoDescontoTotal.css";

const AcrescimoDescontoTotal = ({
  onClose,
  isVisible,
  precoTotal,
  setPagamentoConcluido,
  setPagItem,
  pagamentos,
  setPagamentos,
  acresDescFrete,
  setAcresDescFrete,
  produtos,
  setProdutos,
  CalcularTotais,
  subTotal,
  setAcrescimoDescontosFreteConcluido }
) => {
  const [frete, setFrete] = useState(0);
  const [desconto, setDesconto] = useState(0);
  const [acrescimo, setAcrescimo] = useState(0);




  useEffect(() => {
    if (acresDescFrete) {
      setFrete(acresDescFrete.frete);
      setDesconto(acresDescFrete.descTotal);
      setAcrescimo(acresDescFrete.acresTotal);
    }
  }, []);


  const [quantidade, setQuantidade] = useState(0);

  const [valorAcrescimo, setValorAcrescimo] = useState(0);

  const [valorDesconto, setValorDesconto] = useState(0);
  const [valorPreco, setValorPreco] = useState(0);

  const [isloading, setIsLoading] = useState(true);
  const [liberarAcrescimo, setLiberarAcrescimo] = useState(false);
  const [liberarDesconto, setLiberarDesconto] = useState(false);

  const handleSave = async () => {
    const produtosAux = await calcularDescontos();
    await calcularAcrescimosEFrete(produtosAux);
    const acresDescFreteAux = {
      acresTotal: acrescimo,
      descTotal: desconto,
      frete: frete,
    };
    setAcresDescFrete(acresDescFreteAux);

    CalcularTotais();
    setAcrescimoDescontosFreteConcluido(true);
    onClose();
  };

  const calcularDescontos = async () => {
    const produtosAux = produtos;

    var valorDeProdutosComDescontoZero = 0;
    var porcentagemEquivalenteDesconto = (valorDesconto / subTotal) * 100;

    if (produtosAux) {
      await produtosAux.map(produto => {
        if (produto.valorDesconto == 0) {
          valorDeProdutosComDescontoZero += produto.quantidade * produto.preco;
        }
      });



      await produtosAux.map((produto, index) => {
        if (produto.valorDesconto == 0) {
          produto.valorDesconto =
            produto.quantidade *
            produto.preco *
            (porcentagemEquivalenteDesconto / 100);
        }
      });
      setProdutos(produtosAux);
    }









    return produtosAux;
  };


  const calcularAcrescimosEFrete = async produtosAux => {
    const ehServico = produto => {
      const tipoItem =
        produto?.ntipoItem ??
        produto?.nTipoItem ??
        produto?.tipoItem ??
        0;

      return Number(tipoItem) === 5;
    };

    const quantidadeProdutosComFrete = produtosAux.filter(
      produto => !ehServico(produto),
    ).length;

    const fretePorProduto =
      quantidadeProdutosComFrete > 0
        ? Math.floor(frete / quantidadeProdutosComFrete)
        : 0;

    const totalFreteDistribuido =
      fretePorProduto * quantidadeProdutosComFrete;

    const excedenteFrete =
      quantidadeProdutosComFrete > 0
        ? frete - totalFreteDistribuido
        : 0;

    let indiceProdutoComFrete = 0;

    if (valorAcrescimo > 0) {
      let valorDeProdutosComAcrescimoZero = 0;
      let totalDescontos = 0;

      produtosAux.forEach(produto => {
        totalDescontos += Number(
          produto?.valorDesconto || 0,
        );

        if (Number(produto?.valorAcrescimo || 0) === 0) {
          valorDeProdutosComAcrescimoZero +=
            Number(produto?.quantidade || 0) *
            Number(produto?.preco || 0) -
            Number(produto?.valorDesconto || 0);
        }
      });

      const baseCalculoAcrescimo =
        Number(subTotal || 0) - totalDescontos;

      const porcentagemEquivalenteAcrescimo =
        baseCalculoAcrescimo > 0
          ? (Number(valorAcrescimo || 0) /
            baseCalculoAcrescimo) *
          100
          : 0;

      produtosAux.forEach(produto => {
        if (Number(produto?.valorAcrescimo || 0) === 0) {
          produto.valorAcrescimo =
            (
              Number(produto?.quantidade || 0) *
              Number(produto?.preco || 0) -
              Number(produto?.valorDesconto || 0)
            ) *
            (porcentagemEquivalenteAcrescimo / 100);
        }

        if (ehServico(produto)) {
          produto.frete = 0;
          return;
        }

        const ehUltimoProdutoComFrete =
          indiceProdutoComFrete ===
          quantidadeProdutosComFrete - 1;

        produto.frete = ehUltimoProdutoComFrete
          ? fretePorProduto + excedenteFrete
          : fretePorProduto;

        indiceProdutoComFrete++;
      });
    } else {
      produtosAux.forEach(produto => {
        if (ehServico(produto)) {
          produto.frete = 0;
          return;
        }

        const ehUltimoProdutoComFrete =
          indiceProdutoComFrete ===
          quantidadeProdutosComFrete - 1;

        produto.frete = ehUltimoProdutoComFrete
          ? fretePorProduto + excedenteFrete
          : fretePorProduto;

        indiceProdutoComFrete++;
      });
    }

    setProdutos([...produtosAux]);
  };

  const styles = {
    container: {
      width: "100%",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#fff",
      padding: 20,
      boxSizing: "border-box",
    },
    header: {
      fontSize: 24,
      marginBottom: 20,
    },
    section: {
      width: "100%",
      maxWidth: 400,
      marginBottom: 20,
      textAlign: "center",
    },
    label: {
      fontSize: 16,
      marginBottom: 8,
      fontWeight: "bold",
    },
    inputGroup: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
    },
    iconButton: {
      backgroundColor: "black",
      color: "white",
      fontSize: 16,
      width: 40,
      height: 40,
      border: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    input: {
      width: 60,
      textAlign: "center",
    },
    buttonGroup: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      maxWidth: 400,
      marginTop: 20,
    },
    cancelButton: {
      backgroundColor: "red",
      color: "white",
      fontWeight: "bold",
      border: "none",
      width: "48%",
    },
    confirmButton: {
      backgroundColor: "green",
      color: "white",
      fontWeight: "bold",
      border: "none",
      width: "48%",
    },
    total: {
      marginTop: 20,
      backgroundColor: "#e0e0e0",
      padding: 10,
      borderRadius: 8,
      textAlign: "left",
      maxWidth: 400,
      width: "100%",
    },
    totalText: {
      margin: "4px 0",
    },
  };
  const totalComAjustes =
    Number(subTotal || 0) -
    Number(valorDesconto || 0) +
    Number(valorAcrescimo || 0) +
    Number(frete || 0);


  const estiloMoneyInputCentral = {
    width: '100%',
    minWidth: 0,
    height: '44px',
    display: 'flex',
  };

  const estiloPaginaAjustes = {
    width: '100%',
    padding: '12px',
    background: '#f4f6f9',
    boxSizing: 'border-box',
  };

  const estiloCardAjustes = {
    width: '100%',
    maxWidth: '900px',
    margin: '0 auto',
    padding: '16px',
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '16px',
    boxShadow: '0 8px 24px rgba(15, 23, 42, 0.08)',
    boxSizing: 'border-box',
  };

  const estiloCabecalhoAjustes = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    paddingBottom: '12px',
    marginBottom: '12px',
    borderBottom: '1px solid #e5e7eb',
  };

  const estiloTituloAjustes = {
    margin: 0,
    color: '#111827',
    fontSize: '20px',
    fontWeight: '800',
  };

  const estiloSubtituloAjustes = {
    display: 'block',
    marginTop: '3px',
    color: '#6b7280',
    fontSize: '13px',
  };

  const estiloIconeCabecalho = {
    width: '44px',
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '12px',
    background: '#f3f4f6',
    fontSize: '23px',
  };

  const estiloGridAjustes = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: '10px',
    alignItems: 'stretch',
  };

  const estiloSecaoAjuste = {
    padding: '12px',
    background: '#f8fafc',
    border: '1px solid #e5e7eb',
    borderRadius: '12px',
    boxSizing: 'border-box',
  };

  const estiloTituloSecao = {
    margin: '0 0 10px',
    color: '#374151',
    fontSize: '14px',
    fontWeight: '800',
  };

  const estiloDescricaoSecao = {
    display: 'block',
    marginBottom: '8px',
    color: '#6b7280',
    fontSize: '12px',
  };

  const estiloFreteContainer = {
    width: '100%',
  };

  const estiloResumoAjustes = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: '10px',
    marginTop: '10px',
  };

  const estiloCardResumo = {
    padding: '12px',
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '12px',
  };

  const estiloLabelResumo = {
    display: 'block',
    marginBottom: '4px',
    color: '#6b7280',
    fontSize: '12px',
    fontWeight: '700',
  };

  const estiloValorResumo = {
    color: '#111827',
    fontSize: '18px',
    fontWeight: '900',
  };

  const estiloCardTotal = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    marginTop: '10px',
    padding: '14px 18px',
    background: 'linear-gradient(135deg, #18181b, #000000)',
    borderRadius: '12px',
    color: '#ffffff',
    boxShadow: '0 7px 18px rgba(0, 0, 0, 0.2)',
  };

  const estiloLabelTotal = {
    color: '#d1d5db',
    fontSize: '12px',
    fontWeight: '700',
    textTransform: 'uppercase',
  };

  const estiloValorTotal = {
    color: '#ffffff',
    fontSize: '24px',
    fontWeight: '900',
  };

  const estiloRodape = {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px',
    paddingTop: '12px',
    marginTop: '12px',
    borderTop: '1px solid #e5e7eb',
  };

  const estiloBotaoBase = {
    minHeight: '40px',
    padding: '8px 18px',
    borderRadius: '9px',
    fontSize: '14px',
    fontWeight: '800',
    cursor: 'pointer',
  };

  const estiloBotaoCancelar = {
    minWidth: '110px',
    minHeight: '42px',
    padding: '9px 18px',
    border: '1px solid #dc2626',
    borderRadius: '9px',
    background: 'linear-gradient(135deg, #ef4444, #b91c1c)',
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: '800',
    cursor: 'pointer',
    boxShadow: '0 5px 12px rgba(220, 38, 38, 0.20)',
  };

  const estiloBotaoConfirmar = {
    ...estiloBotaoBase,
    border: '1px solid #000000',
    background: 'linear-gradient(135deg, #27272a, #000000)',
    color: '#ffffff',
    boxShadow: '0 5px 12px rgba(0, 0, 0, 0.22)',
  };


  const estiloCampo = {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    minWidth: 0,
  };

  const estiloLabel = {
    color: '#374151',
    fontSize: '12px',
    fontWeight: '700',
    textAlign: 'left',
  };

  const estiloGrupoInput = {
    display: 'grid',
    gridTemplateColumns:
      '42px minmax(0, 1fr) 42px',
    width: '100%',
  };

  const estiloInputGrupo = {
    width: '100%',
    minWidth: 0,
    height: '40px',
    padding: '0 8px',
    border: '1px solid #cbd5e1',
    borderRadius: 0,
    background: '#ffffff',
    color: '#111827',
    fontSize: '14px',
    textAlign: 'center',
    outline: 'none',
    boxSizing: 'border-box',
  };

  const estiloBotaoInputEsquerdo = {
    height: '40px',
    border: '1px solid #cbd5e1',
    borderRight: 'none',
    borderRadius: '9px 0 0 9px',
    background: '#eef2ff',
    color: '#312e81',
    fontSize: '17px',
    fontWeight: '800',
    cursor: 'pointer',
  };

  const estiloBotaoInputDireito = {
    height: '40px',
    border: '1px solid #cbd5e1',
    borderLeft: 'none',
    borderRadius: '0 9px 9px 0',
    background: '#eef2ff',
    color: '#312e81',
    fontSize: '15px',
    fontWeight: '800',
    cursor: 'pointer',
  };
  return (
    <div style={estiloPaginaAjustes}>
      <div style={estiloCardAjustes}>
        <div style={estiloCabecalhoAjustes}>
          <div>
            <h2 style={estiloTituloAjustes}>
              Acréscimos e Descontos
            </h2>

            <span style={estiloSubtituloAjustes}>
              Ajuste desconto, acréscimo e frete da venda.
            </span>
          </div>

          <div style={estiloIconeCabecalho}>
            💲
          </div>
        </div>

        <div style={estiloGridAjustes}>
          {/* Desconto */}
          <div style={estiloSecaoAjuste}>
            <h3 style={estiloTituloSecao}>
              🔻 Desconto
            </h3>

            <span style={estiloDescricaoSecao}>
              Informe um valor ou percentual.
            </span>

            <div style={estiloGrupoInput}>
              <button
                type="button"
                style={estiloBotaoInputEsquerdo}
                title="Aplicar como valor"
                onClick={() => {
                  if (
                    Number(subTotal || 0) >
                    Number(desconto || 0)
                  ) {
                    setValorDesconto(
                      Number(desconto || 0)
                    );
                  }
                }}
              >
                ↓
              </button>

              <input
                style={estiloInputGrupo}
                type="number"
                min="0"
                step="0.01"
                value={desconto}
                onChange={(e) =>
                  setDesconto(e.target.value)
                }
              />

              <button
                type="button"
                style={estiloBotaoInputDireito}
                title="Aplicar como porcentagem"
                onClick={() => {
                  if (
                    Number(desconto || 0) >= 0 &&
                    Number(desconto || 0) < 100
                  ) {
                    setValorDesconto(
                      (
                        Number(desconto || 0) / 100
                      ) * Number(subTotal || 0)
                    );
                  }
                }}
              >
                %
              </button>
            </div>
          </div>

          {/* Acréscimo */}
          <div style={estiloSecaoAjuste}>
            <h3 style={estiloTituloSecao}>
              🔺 Acréscimo
            </h3>

            <span style={estiloDescricaoSecao}>
              Informe um valor ou percentual.
            </span>

            <div style={estiloGrupoInput}>
              <button
                type="button"
                style={estiloBotaoInputEsquerdo}
                title="Aplicar como valor"
                onClick={() => {
                  setValorAcrescimo(
                    Number(acrescimo || 0)
                  );
                }}
              >
                ↑
              </button>

              <input
                style={estiloInputGrupo}
                type="number"
                min="0"
                step="0.01"
                value={acrescimo}
                onChange={(e) =>
                  setAcrescimo(e.target.value)
                }
              />

              <button
                type="button"
                style={estiloBotaoInputDireito}
                title="Aplicar como porcentagem"
                onClick={() => {
                  if (
                    Number(acrescimo || 0) >= 0 &&
                    Number(acrescimo || 0) < 100
                  ) {
                    setValorAcrescimo(
                      (
                        Number(acrescimo || 0) / 100
                      ) *
                      (
                        Number(subTotal || 0) -
                        Number(valorDesconto || 0)
                      )
                    );
                  }
                }}
              >
                %
              </button>
            </div>
          </div>

          {/* Frete */}
          <div style={estiloSecaoAjuste}>
            <h3 style={estiloTituloSecao}>
              🚚 Frete
            </h3>

            <span style={estiloDescricaoSecao}>
              Informe o valor do frete.
            </span>

            <input
              style={{
                ...estiloInputGrupo,
                borderRadius: '10px',
                textAlign: 'left',
                padding: '0 12px',
              }}
              type="number"
              min="0"
              step="0.01"
              value={frete}
              onChange={(e) =>
                setFrete(e.target.value)
              }
            />
          </div>
        </div>

        <div style={estiloResumoAjustes}>
          <div style={estiloCardResumo}>
            <span style={estiloLabelResumo}>
              Desconto aplicado
            </span>

            <span style={estiloValorResumo}>
              {Number(valorDesconto || 0).toLocaleString(
                'pt-BR',
                {
                  style: 'currency',
                  currency: 'BRL',
                }
              )}
            </span>
          </div>

          <div style={estiloCardResumo}>
            <span style={estiloLabelResumo}>
              Acréscimo aplicado
            </span>

            <span style={estiloValorResumo}>
              {Number(valorAcrescimo || 0).toLocaleString(
                'pt-BR',
                {
                  style: 'currency',
                  currency: 'BRL',
                }
              )}
            </span>
          </div>

          <div style={estiloCardResumo}>
            <span style={estiloLabelResumo}>
              Frete
            </span>

            <span style={estiloValorResumo}>
              {Number(frete || 0).toLocaleString(
                'pt-BR',
                {
                  style: 'currency',
                  currency: 'BRL',
                }
              )}
            </span>
          </div>
        </div>

        <div style={estiloCardTotal}>
          <div>
            <div style={estiloLabelTotal}>
              Total após ajustes
            </div>

            <div style={estiloValorTotal}>
              {totalComAjustes.toLocaleString(
                'pt-BR',
                {
                  style: 'currency',
                  currency: 'BRL',
                }
              )}
            </div>
          </div>

          <span style={{ fontSize: '28px' }}>
            🧾
          </span>
        </div>

        <div style={estiloRodape}>
          <button
            type="button"
            style={estiloBotaoCancelar}
            onClick={onClose}
          >
            Cancelar
          </button>

          <button
            type="button"
            style={estiloBotaoConfirmar}
            onClick={handleSave}
          >
            ✓ Confirmar
          </button>
        </div>
      </div>
    </div>
  );
};

export default AcrescimoDescontoTotal;
